import { render, staticRenderFns } from "./PresentationName.vue?vue&type=template&id=70967054&scoped=true&"
import script from "./PresentationName.vue?vue&type=script&lang=js&"
export * from "./PresentationName.vue?vue&type=script&lang=js&"
import style0 from "./PresentationName.vue?vue&type=style&index=0&id=70967054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70967054",
  null
  
)

export default component.exports